import styled from 'styled-components';

export const SectionWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing[16],
  flexDirection: 'column',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  borderRadius: theme.spacing[4],
  border: `1px solid ${theme.colors.surface04}`,
  backgroundColor: theme.colors.highEmphasisWhite,

  [`${theme.mediaBreakpointDown.md}`]: {
    border: 'none',
    boxShadow: theme.elevation[3],
  },
}));
